import React, { useEffect } from "react";
import styled from "styled-components";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import { Spin, notification } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import environment from "../../config/environment";

const LoginPage = (props: any) => {
  const { search } = useLocation();
  const query: any = queryString.parse(search);
  const dispatch = useDispatch();
  const history = useHistory();
  const LoginStyle = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-wrap: nowrap;
    background-color: #fff;
    justify-content: center;
    align-items: center;
    text-align: center;
    animation: float 3s ease-in-out infinite;
    span {
      margin-left: 1rem;
    }
    @keyframes float {
      0% {
        transform: translatey(0px);
      }
      50% {
        transform: translatey(-20px);
      }
      100% {
        transform: translatey(0px);
      }
    }
  `;

  useEffect(() => {
    console.log("environment", environment?.baseApi);
    // if (query?.from !== undefined && query?.reques !== undefined && query?.type !== undefined) {
    if (
      query?.from !== undefined || query?.reques !== undefined || query?.customerid !== undefined || query?.token !== undefined) {
      localStorage.setItem("param_from", query?.from);
      localStorage.setItem("param_reques", query?.reques);
      localStorage.setItem("param_customer", query?.customerid);
      localStorage.setItem("param_token", query?.token);
      
      if (query?.identifier !== undefined || query?.ndid_phase !== undefined){
        localStorage.setItem("param_identifier", query?.identifier);
        localStorage.setItem("param_ndid_phase", query?.ndid_phase);
      }
  
      dispatch({
        type: "isFetchedUser",
        payload: true,
      });
      if (query?.customerid === undefined) {
        history.push(`/home?from=${query?.from}&reques=${query?.reques}`);
      } else if (query?.token !== undefined) {
        history.push(`/home?from=${query?.from}&reques=${query?.reques}&token=${query?.token}`);
      } else {
        history.push(`/home?from=${query?.from}&reques=${query?.reques}&customerid=${query?.customerid}`);
      }
    } else {
      notification.open({
        message: "Require",
        description: "This request is require parameter 'from, reques, type'!",
        duration: 0,
        icon: <CloseCircleOutlined />,
      });
    }
  }, []);
  return (
    <>
      <LoginStyle>
        <div className="row">
          <div className="col-12">
            {" "}
            <img className="logo" width="auto" src="https://ktbst-daolgroup-staticsite.s3.ap-southeast-1.amazonaws.com/daol.png" alt="DAOL" />
          </div>
          <div className="col-12"></div>
          <div className="col-12">
            <Spin /> <span>Loading...</span>
          </div>
        </div>
      </LoginStyle>
    </>
  );
};
export default LoginPage;
